import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { DocumentService, UserService } from '@app/shared/services';
import { MxTaskbarService } from '@app/shared/services/mx-taskbar/mx-taskbar.service';
import { MxconnectionService } from '@app/shared/services/vault/mxconnection.service';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription } from 'rxjs';
import * as widgetSdk from '@mxenabled/web-widget-sdk';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { MxSelectVaultModalComponent } from './mx-select-vault-modal/mx-select-vault-modal.component';
import { AnimationOptions } from 'ngx-lottie';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SharedVaultService } from '@app/shared/services/vault/shared-vault.service';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'connect-to-mx',
  templateUrl: './connect-to-mx.component.html',
  styleUrls: ['./connect-to-mx.component.scss'],
})
export class ConnectToMxComponent implements OnInit, OnDestroy {
  @ViewChild('mxIframeContainer', { static: true }) mxIframeContainer: ElementRef;
  @Output() mxDialogMinimized = new EventEmitter<string>();
  myControl = new FormControl('');

  selectInstitution = false;
  enable_linking = false;
  mxDatList = [];
  isLoadingData = true;
  subscription = new Subscription();
  isLoading = false;
  type_template;
  numberChange = 0;
  loaderItems = [{ id: 1 }, { id: 2 }, { id: 3 }];
  userId;
  allowedOne = false;
  mx_connected_clients = [];
  account_selected;
  title = 'Financial Institution';
  selected_institution_data = null;
  currentFormId;
  formName;
  dialogId: string;
  showFooter = false;
  hideMxWidget = false;
  showContextText = false;
  stop_form_creation = false;
  isAPICalled = false;
  vaults = [];
  currentUser;
  savingForm = false;
  filteredVaults$: { [key: string]: Observable<any[]> } = {};
  multiVaultSelected = false;
  selectedAccounts = [];
  private widgetInstance: widgetSdk.ConnectWidget | null = null;
  private widgetInstances = new Map<string, any>();
  // private widgetInstances: { [dialogId: string]: any } = {};
  // private mxConnectInstance: MXConnect | null = null;
  private sessionGuidToDialogIdMap: Map<string, string> = new Map();
  questionContentAnimationOptions: AnimationOptions = {
    path: 'assets/images/lottie-img/question-content-animation.json',
  };
  templates: any = [];
  allSelected = false;
  institution: any;

  constructor(
    private mxconnectionService: MxconnectionService,
    private cd: ChangeDetectorRef,
    private userService: UserService,
    private dialog: MatDialog,
    private mxTaskbarService: MxTaskbarService,
    private toastr: ToastrService,
    private _loginService: LoginStoreEffects,
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<ConnectToMxComponent>,
    private vaultService: VaultStoreEffects,
    private sharedVaultService: SharedVaultService,
    private documentService: DocumentService
  ) {
    this.dialogId = data.dialogId;
  }

  updateData() {
    this.subscription.add(
      this.userService
        .getUpdatedData({
          userId: this.userId,
          ...(this.data?.workspace_id && { workspace_id: this.data.workspace_id, workspace_user_id: this.data?.workspace_user_id }),
        })
        .subscribe(() => {
          if (this.selected_institution_data != null) {
            this.selectInstitution = true;
            this.getUserData(true);
            this.cd.detectChanges();
          } else {
            this.dialogRef.close({
              success: true,
            });
          }
        })
    );
  }

  toggleCheckbox(item: any) {
    item.checked = !item.checked;
    this.cd.detectChanges();
  }
  ngOnInit(): void {
    document.addEventListener('click', this.handleDocumentClick, true);

    this.userId = this.data.currentValutUserId;
    this.formName = this.data.formName;
    this.currentFormId = this.data.currentFormId;
    this.allowedOne = this.data.allowedOne ? this.data.allowedOne : false;
    this.stop_form_creation = this.data.stop_form_creation ? this.data.stop_form_creation : false;
    this.enable_linking = this.data.enable_linking ? this.data.enable_linking : false;
    this.mx_connected_clients = this.data.mx_connected_clients;
    this.title = this.data.title ?? this.title;
    this.type_template = this.data.type_template;

    if (this.data?.isUpdate) {
      this.updateToMX();
    } else {
      this.connectToMX(this.dialogId);
    }
    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.vaults = state.vaults;
        this.getUnlinkedForm();
      })
    );

    this.subscription.add(
      this._loginService.loginObject.subscribe((state) => {
        if (state && state.data) {
          this.currentUser = state.data;
        }
      })
    );
  }
  getUnlinkedForm() {
    this.subscription.add(
      this.sharedVaultService.getUnlinkedForm().subscribe((res) => {
        this.templates = res;
        // Update templates for all user accounts after templates are loaded
        this.updateTemplatesForUserAccounts();
      })
    );
  }

  getFilteredTemplate(item: any): any {
    if (!this.templates || !item.vaultUserForm?.vault_form_id) {
      return null;
    }

    // Filter templates based on vault_form_id
    const filteredTemplate = this.templates.find((template) => template.vault_form_id === item.vaultUserForm.vault_form_id);

    return filteredTemplate || null;
  }

  updateTemplatesForUserAccounts() {
    if (this.mxDatList && this.mxDatList.length > 0 && this.mxDatList[0].userAccounts) {
      this.mxDatList[0].userAccounts = this.mxDatList[0].userAccounts.map((item) => ({
        ...item,
        template: this.getFilteredTemplate(item),
      }));
      // Trigger change detection to update save button state
      this.cd.detectChanges();
    }
  }
  getVaultIcon(type: string): string {
    switch (type) {
      case 'personal':
        return 'assets/images/vault/personal.svg';
      case 'shared':
        return 'assets/images/vault/shared.svg';
      case 'holding':
      case 'trust':
        return 'assets/images/vault/entity.svg';
      default:
        return 'assets/images/vault/personal.svg';
    }
  }

  async processVaultCreation() {
    this.isLoading = true;
    this.cd.detectChanges();
    const promises = [];

    // Process vault creation and form linking
    for (let index = 0; index < this.mxDatList[0]?.userAccounts.length; index++) {
      const element = this.mxDatList[0]?.userAccounts[index];

      // Handle different actions
      if (element) {
        if (element.action === 'exclude') {
          // For exclude action, we don't need a vault, just create the account with exclude action
          promises.push(this.createUserMemberAccountSingle(element));
        } else if (element.searchControl?.value?.id) {
          // For create/existing actions, we need a vault selected
          promises.push(this.createUserMemberAccountSingle(element));

          // Add updateUserLinkedForm call if template is selected
          if (element.template && element.template.id) {
            promises.push(this.updateUserLinkedFormSingle(element));
          }

          // Add updateFormGroupId call based on specific conditions
          if (element.template && element.template.id && element.vault && element.vault.id) {
            if (element.action === 'existing') {
              // For existing action, only call if user manually changed the pre-selected vault
              if (element.vaultManuallyChanged) {
                promises.push(this.updateFormGroupIdSingle(element));
              }
            }
          }
        }
      }
    }

    await Promise.allSettled(promises);

    if (this.currentFormId) {
      try {
        this.subscription.add(
          this.userService.createUserMemberLinking({ vault_user_form_id: this.currentFormId, member_guid: this.mxDatList[0].guid }).subscribe(() => {
            this.dialogRef.close({
              success: true,
              selected_institution_data: this.selected_institution_data,
              userAccounts: this.allowedOne ? [this.account_selected] : this.mxDatList[0]?.['userAccounts'] || [],
            });
          })
        );
      } catch (error) {
        console.error('🚀 ~ ConnectToMxComponent ~ processVaultCreation ~ error:', error);
        // Even if there's an error, close the dialog with the data
        this.dialogRef.close({
          success: true,
          selected_institution_data: this.selected_institution_data,
          userAccounts: this.allowedOne ? [this.account_selected] : this.mxDatList[0]?.['userAccounts'] || [],
        });
      }
    } else {
      this.dialogRef.close({
        success: true,
        selected_institution_data: this.selected_institution_data,
        userAccounts: this.allowedOne ? [this.account_selected] : this.mxDatList[0]?.['userAccounts'] || [],
      });
    }
  }

  async linkAccountAssociate() {
    // If mxDatList is empty but we have selected_institution_data, it means all accounts are already linked
    if (this.mxDatList.length === 0 && this.selected_institution_data) {
      this.processVaultCreation();
      return;
    }

    // Check if there are any accounts that need vault selection (no vault selected and not already linked)
    const hasUnassignedAccounts = this.mxDatList[0]?.userAccounts.some((x) => !x.searchControl.value && !x.vault_user_form_id);

    if (!hasUnassignedAccounts) {
      // All accounts are either already linked or have vaults selected, proceed with creation
      this.processVaultCreation();
    } else {
      // Some accounts don't have vaults selected, show warning dialog
      const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
        width: '386px',
        data: {
          title: `Account(s) Not Paired`,
          materialIcon: 'warning',
          text: `One or more accounts has not been assigned to a vault, which means they will not be visible. If you want to move them into a vault in the future you may do so from the 'data feeds register' within this account.`,
          backBUttonTitle: 'Go Back',
          proceedTitle: 'Save & Continue',
        },
      });

      this.subscription.add(
        sharedDialogRef.afterClosed().subscribe((confirmation) => {
          if (confirmation) {
            this.processVaultCreation();
          }
        })
      );
    }
  }
  linkAccount() {
    if (this.account_selected == null) {
      return;
    }
    const item = this.account_selected;
    const fData = { guid: item.guid, vault_user_form_id: this.currentFormId };
    if (item.vault_user_form_id) {
      const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
        width: '400px',
        data: {
          title: `Link ${item.name}?`,
          materialIcon: 'info',
          text: `${item.name} is currently linked to ${item.vaultUserForm.form_name}. Would you like to link it to ${this.formName} instead?`,
          proceedTitle: 'Yes, link it',
        },
      });
      this.subscription.add(
        sharedDialogRef.afterClosed().subscribe((confirmation) => {
          if (confirmation) {
            this.addOrUpdateForm(fData, item, item.member_guid);
          }
        })
      );
    } else {
      this.addOrUpdateForm(fData, item, item.member_guid);
    }
  }
  addOrUpdateForm(fData, item, member_guid) {
    if (this.mx_connected_clients?.length > 0) {
      try {
        const deleteData = { guid: this.mx_connected_clients[0].guid, vault_user_form_id: null };
        this.subscription.add(
          this.userService.updateUserLinkedForm(deleteData).subscribe(() => {
            this.updateLinked(fData, member_guid);
          })
        );
      } catch (error) {
        console.error('🚀 ~ ConnectToMxComponent ~ addOrUpdateForm ~ error:', error);
      }
    } else {
      this.updateLinked(fData, member_guid);
    }
  }
  updateLinked(fData, member_guid) {
    this.subscription.add(
      this.userService.updateUserLinkedForm(fData).subscribe(() => {
        this.toastr.success('Form linked successfully.');
        this.subscription.add(
          this.userService
            .createFormUnLinkedForm({
              member_guid: member_guid,
              source_vault_user_form_id: this.currentFormId,
              user_id: this.userId,
            })
            .subscribe(
              () => {
                this.dialogRef.close({
                  success: true,
                  selected_institution_data: this.selected_institution_data,
                });
              },
              (error) => {
                console.error('🚀 ~ ConnectToMxComponent ~ this.userService.updateUserLinkedForm ~ error:', error);
              }
            )
        );
      })
    );
  }
  onActionChange(item: any) {
    if (item.action === 'create') {
      item.template = '';
    }
    // Trigger change detection to update save button state
    this.cd.detectChanges();
  }

  // Add validation method to check if all accounts have proper selections
  isSaveButtonDisabled(): boolean {
    if (!this.mxDatList || this.mxDatList.length === 0 || !this.mxDatList[0]?.userAccounts) {
      return true;
    }

    const userAccounts = this.mxDatList[0].userAccounts;

    // Check if any account is missing required selections
    for (const account of userAccounts) {
      // Skip accounts that are already linked
      if (account.vault_user_form_id) {
        continue;
      }

      // Check if action is selected
      if (!account.action || account.action === '') {
        return true;
      }

      // Check specific requirements based on action
      switch (account.action) {
        case 'create':
          // For create action, vault is required
          if (!account.searchControl.value) {
            return true;
          }
          break;
        case 'existing':
          // For existing action, template is required
          if (!account.template) {
            return true;
          }
          break;
        case 'exclude':
          // For exclude action, no additional selection needed
          break;
        default:
          // Unknown action type
          return true;
      }
    }

    return false;
  }
  closeDialog(isFromSuccess = false) {
    if (isFromSuccess) {
      this.subscription.add(
        this.userService
          .getUpdatedData({
            userId: this.userId,
            ...(this.data?.workspace_id && { workspace_id: this.data.workspace_id, workspace_user_id: this.data?.workspace_user_id }),
          })
          .subscribe(() => {
            if (this.stop_form_creation) {
              this.dialogRef.close({
                success: true,
              });
              return;
            }

            if (this.selected_institution_data != null) {
              this.selectInstitution = true;
              this.getUserData(true);
              this.isAPICalled = false;
              this.cd.detectChanges();
            } else {
              this.dialogRef.close({
                success: true,
                selected_institution_data: this.selected_institution_data,
              });
            }
          })
      );
    } else {
      this.dialogRef.close({
        success: true,
      });
    }
  }

  closeInstitution() {
    this.dialogRef.close({
      success: true,
      selected_institution_data: this.selected_institution_data,
    });
  }

  successDialog() {
    // this.toastr.success('Member Added Successfully.');
    this.closeDialog(true);
  }
  onCheckboxChangeAll(event) {
    // Don't process if all items are disabled
    if (this.areAllItemsDisabled()) {
      return;
    }

    this.allSelected = event.checked;
    if (event.checked) {
      this.mxDatList[0]?.userAccounts.forEach((x) => {
        if (!x.vault_user_form_id) {
          x.checked = true;
        }
      });
      this.selectedAccounts = this.mxDatList[0]?.userAccounts.filter((a) => a.checked);
    } else {
      this.mxDatList[0]?.userAccounts.forEach((x) => {
        x.checked = false;
      });
      this.selectedAccounts = [];
    }
    this.numberChange = Math.floor(Math.random() * (1000 - 0 + 1)) + 0;
    // Trigger change detection to update save button state
    this.cd.detectChanges();
  }

  // Check if all table items are disabled (have vault_user_form_id)
  areAllItemsDisabled(): boolean {
    const tableData = this.getTableDataSource();
    if (tableData.length === 0) return true;

    return tableData.every((item) => item.vault_user_form_id);
  }

  // Check if header checkbox should be disabled
  isHeaderCheckboxDisabled(): boolean {
    return this.areAllItemsDisabled();
  }
  onCheckboxChange() {
    this.numberChange = Math.floor(Math.random() * (1000 - 0 + 1)) + 0;
    this.selectedAccounts = this.mxDatList[0]?.userAccounts.filter((a) => a.checked);
    // Trigger change detection to update save button state
    this.cd.detectChanges();
  }
  onVaultSelection(selectedVault: any, selectedUserAccount: any) {
    if (selectedUserAccount.checked) {
      this.mxDatList[0]?.userAccounts.forEach((user) => {
        if (user.checked) {
          user.searchControl.setValue(selectedVault, { emitEvent: false });
          user.isFocused = false;
          user.checked = false;
        }
      });
    } else {
      selectedUserAccount.searchControl.setValue(selectedVault, { emitEvent: false });
      selectedUserAccount.isFocused = false;
    }
    this.cd.detectChanges();
  }

  getSelectedValueFromChecked() {
    const firstSelected = this.mxDatList[0]?.userAccounts.find((item) => item.checked && item.searchControl.value);
    return firstSelected?.searchControl?.value || null;
  }

  getFormFieldClass(item: any): string {
    const base = 'w-full h-[48px] mx-connect-select';

    if (item.checked && item.searchControl.value) {
      return `${base} selected-mx-connect`; // Green for selected
    } else if (item.checked) {
      return `${base} checked-mx-connect`; // Blue for just checked
    } else {
      return `${base} non-selected-mx-connect`; // Default gray
    }
  }
  getVault(item: any): any {
    return item?.vault || item?.vaultUserForm?.vaultUserFolder?.vault;
  }

  createUserMemberAccountSingle(selectedAccounts) {
    return new Promise((resolve) => {
      this.subscription.add(
        this.userService
          .createUserMemberAccountSingle({
            user_id: this.userId,
            user_account_guid: selectedAccounts.guid,
            vault_id: selectedAccounts.action === 'exclude' ? null : selectedAccounts.searchControl.value.id,
            id: this.currentFormId,
            action: selectedAccounts.action,
          })
          .subscribe((res) => {
            resolve(res);
          })
      );
    });
  }
  updateFormGroupIdSingle(element) {
    return new Promise((resolve) => {
      this.subscription.add(
        this.documentService
          .updateFormGroupId({
            id: [element.template.id],
            vault_id: element.vault.id,
            vault_user_id: this.userId,
          })
          .subscribe((res) => {
            resolve(res);
          })
      );
    });
  }
  updateUserLinkedFormSingle(element) {
    return new Promise((resolve) => {
      this.subscription.add(
        this.userService
          .updateUserLinkedForm({
            guid: element.guid,
            vault_user_form_id: element.template.id,
          })
          .subscribe((res) => {
            resolve(res);
          })
      );
    });
  }
  onSelectVault() {
    const dialogRef = this.dialog.open(MxSelectVaultModalComponent, {
      width: '687px',
      maxWidth: '90%',
      data: {},
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe(async (val) => {
        if (val.id) {
          this.multiVaultSelected = true;
          this.mxDatList[0]?.userAccounts.forEach((x) => {
            if (x.checked) {
              const vault = this.vaults.find((v) => v.id === val.id);
              x.searchControl.setValue(vault);
            }
          });
          this.cd.detectChanges();
        }
      })
    );
  }
  onClearSelection() {
    this.mxDatList[0]?.userAccounts.forEach((x) => (x.checked = false));
    this.selectedAccounts = [];
    this.cd.detectChanges();
  }
  getUserData(allowCreateForm = true) {
    if (allowCreateForm) {
      this.isLoadingData = true;
    }
    this.subscription.add(
      this.mxconnectionService
        .getUserStatusMX(this.data?.workspace_id ? this.data?.workspace_user_id : this.userId, this.data?.workspace_id)
        .subscribe(async (res) => {
          this.mxDatList = [];
          res.mx.forEach((element) => {
            if (element.name === this.selected_institution_data.name && this.mxDatList.length === 0) {
              element.userAccounts = element.userAccounts.map((x) => {
                return {
                  ...x,
                  checked: false,
                  action: 'create',
                  template: this.getFilteredTemplate(x),
                  searchControl: new FormControl({ value: '', disabled: x.vault_user_form_id ? true : false }),
                  showTemplateDropdown: false,
                  templateSearchText: '',
                  filteredTemplates: [],
                  vaultSearchText: '',
                };
              });
              this.mxDatList.push(element);
              // Extract institution data from element.institution[0]
              if (element.institution && element.institution.length > 0) {
                this.institution = element.institution[0];
              } else {
                // Fallback: create institution object from element properties
                this.institution = {
                  name: element.name,
                  medium_logo_url: element.medium_logo_url || '',
                  code: element.institution_code,
                  url: element.url,
                };
              }
            }
          });
          this.initializeSearch();
          this.isLoadingData = false;
          setTimeout(() => {
            const closeButton = document.getElementById(`closeConnect-${this.dialogId}`);
            if (!this.mxDatList.length && closeButton) {
              closeButton.click();
            }
          }, 100);
          this.cd.detectChanges();
        })
    );
  }

  initializeSearch() {
    try {
      this.mxDatList[0]?.userAccounts.forEach((item) => {
        this.filteredVaults$[item.id] = item.searchControl.valueChanges.pipe(
          startWith(''),
          map((value) => this.filterVaults(value))
        );
      });
    } catch (error) {
      console.error('🚀 ~ ConnectToMxComponent ~ initializeSearch ~ error:', error);
    }
  }

  // filterVaults(value: any): any[] {
  //   const filterValue = value.toLowerCase();
  //   return this.vaults.filter((vault) => vault.name.toLowerCase().includes(filterValue));
  // }

  updateToMX() {
    const data = {
      ...this.data.account,
      ...{
        userId: this.userId,
        dialogId: this.dialogId,
        memberGuid: this.data.account.guid,
        ...(this.data?.workspace_id && { workspace_id: this.data.workspace_id, workspace_user_id: this.data?.workspace_user_id }),
      },
    };
    this.subscription.add(
      this.mxconnectionService.updateToMX(data).subscribe((res) => {
        // this.hideMxWidget = true;
        try {
          this.widgetInstance = new widgetSdk.ConnectWidget({
            container: `#widget-${this.dialogId}`,
            iframeTitle: 'Connect',
            url: res.widget_url.url,
            style: {
              height: '670px',
              width: '100%',
            },
            onMessage: (payload) => this.handleMxEvents(payload.data.type, payload.data.metadata),
          });
        } catch (error) {
          console.error('home:connect-mx:updateToMX:Error initializing widget:', error);
        }
        this.cd.detectChanges();
      })
    );
  }
  selectedAccount(item) {
    this.account_selected = item;
  }
  connectToMX(dialogId: string) {
    this.dialogId = dialogId;
    this.subscription.add(
      this.mxconnectionService
        .connectwithMX(this.data?.workspace_id ? this.data?.workspace_user_id : this.userId, this.data?.workspace_id)
        .subscribe((res) => {
          this.hideMxWidget = true;
          try {
            this.widgetInstance = new widgetSdk.ConnectWidget({
              container: `#widget-${dialogId}`,
              iframeTitle: 'Connect',
              url: res.widget_url.url,
              style: {
                height: '670px',
                width: '100%',
              },
              onMessage: (payload) => this.handleMxEvents(payload.data.type, payload.data.metadata),
            });

            (this.widgetInstance as any).dialogId = dialogId;
            // this.widgetInstances[dialogId] = this.widgetInstance;
          } catch (error) {
            console.error('home:connect-mx:connectToMX:Error initializing widget:', error);
          }
          this.cd.detectChanges();
        })
    );
  }

  handleMxEvents(eventName: string, payload: any): void {
    // if (eventName && eventName != 'mx/ping')
    // console.log(`home:connect-mx:[${this.dialogId}] ${eventName} event triggered`, eventName, payload);
    if (eventName === 'mx/connect/loaded') {
      this.hideMxWidget = false;
      this.showFooter = true;
      const sessionGuid = payload.session_guid;
      const existingDialogId = [...this.sessionGuidToDialogIdMap.entries()].length;
      if (sessionGuid && !existingDialogId) {
        this.sessionGuidToDialogIdMap.set(sessionGuid, this.dialogId);
      }
      return;
    }
    const payloadSessionGuid = payload.session_guid;
    if (!payloadSessionGuid) {
      return;
    }

    const registeredDialogId = this.sessionGuidToDialogIdMap.get(payloadSessionGuid);

    if (registeredDialogId && registeredDialogId === this.dialogId) {
      switch (eventName) {
        // case 'mx/load':
        //   this.hideMxWidget = false;
        //   break;
        // case 'mx/connect/loaded':
        //   this.showFooter = true;
        //   break;
        case 'mx/connect/selectedInstitution':
          this.selected_institution_data = payload;
          break;
        case 'mx/connect/memberConnected':
          if (!this.isAPICalled) {
            document.getElementById(`successDialog-${this.dialogId}`).click();
            this.updateMxConnectionStatus();
          }
          this.isAPICalled = true;
          break;
        case 'mx/connect/createMemberError':
          this.showContextText = false;
          this.updateMxConnectionStatus();
          break;
        case 'mx/connect/memberError':
          this.showContextText = false;
          this.updateMxConnectionStatus();
          break;
        case 'mx/connect/stepChange':
          if (payload.current === 'connecting') {
            this.showContextText = true;
          }
          if (payload.current === 'loginError') {
            this.showContextText = false;
          }
          if (payload.current === 'connected' && !this.isAPICalled) {
            this.showContextText = false;
            this.isAPICalled = true;
            this.updateMxConnectionStatus();
            document.getElementById(`successDialog-${this.dialogId}`).click();
          }
          if (payload.current === 'search') {
            this.showFooter = true;
          }
          break;
        default:
        // console.warn(`home:connect-mx:[${this.dialogId}] Unknown event: ${eventName}`);
      }
    }
  }

  handleHelpLink(): void {
    const encodedName = encodeURIComponent(this.currentUser.name ?? '');
    const encodedEmail = encodeURIComponent(this.currentUser.email ?? '');
    window.open(`https://help.kinnect.us/contacts?name=${encodedName}&email=${encodedEmail}`, '_blank');
  }

  updateMxConnectionStatus() {
    this.mxTaskbarService.updateMxConnectionStatus(this.dialogRef, this.dialogId, 'completed');
  }

  minimizeMxDialog() {
    this.mxDialogMinimized.emit(this.data.dialogId);
    this.mxTaskbarService.minimizeMxDialog(this.dialogRef, this.dialogId, this.selected_institution_data?.name);
  }

  handleVaultNameForMultipleNames(vaultName) {
    // return vaultName;
    const hasDuplicateNames = vaultName.trim().split('&');
    if (!hasDuplicateNames[1]) {
      return vaultName;
    }
    const secondName = hasDuplicateNames[1].trim().split('vault');
    return `${hasDuplicateNames[0] + ' ' + '&' + ' ' + secondName[0].trim()}'s Vault`;
  }

  getDicoveryVaultName(value: any) {
    return value?.name;
  }

  getTableDataSource(): any[] {
    const dataSource = [];
    if (this.mxDatList && this.mxDatList.length > 0) {
      this.mxDatList.forEach((account) => {
        if (account.userAccounts && account.userAccounts.length > 0) {
          account.userAccounts.forEach((item) => {
            // Initialize vault dropdown state if not already set
            if (item.showVaultDropdown === undefined) item.showVaultDropdown = false;
            if (item.vaultSearchText === undefined) item.vaultSearchText = '';
            if (item.filteredVaults === undefined) item.filteredVaults = this.vaults;
            if (item.vault === undefined) item.vault = null;
            if (item.action === undefined) item.action = 'create';
            dataSource.push(item);
          });
        }
      });
    }
    return dataSource;
  }

  openVaultDropdown(item: any) {
    // Close all other dropdowns
    this.getTableDataSource().forEach((row) => {
      if (row !== item) row.showVaultDropdown = false;
    });
    item.showVaultDropdown = !item.showVaultDropdown;
    if (item.showVaultDropdown) {
      item.vaultSearchText = '';
      item.filteredVaults = this.vaults;
    }
  }

  selectVault(item: any, vault: any) {
    // Find all checked rows
    const checkedRows = this.getTableDataSource().filter((row) => row.checked);
    if (checkedRows.length > 1) {
      // If multiple rows are checked, apply vault to all checked rows
      checkedRows.forEach((row) => {
        row.vault = vault;
        if (row.searchControl) {
          row.searchControl.setValue(vault, { emitEvent: false });
        }
        row.showVaultDropdown = false;
        // Mark that vault has been manually changed
        row.vaultManuallyChanged = true;
        // Uncheck the row after applying vault
        row.checked = false;
      });
      // Update selectedAccounts array
      this.selectedAccounts = this.mxDatList[0]?.userAccounts.filter((a) => a.checked);
    } else {
      // If no multiple selection, apply vault only to the specific item that was clicked
      item.vault = vault;
      if (item.searchControl) {
        item.searchControl.setValue(vault, { emitEvent: false });
      }
      item.showVaultDropdown = false;
      // Mark that vault has been manually changed
      item.vaultManuallyChanged = true;
    }
    this.cd.detectChanges();
  }

  filterVaults(item: any) {
    if (!item.vaultSearchText) {
      item.filteredVaults = this.vaults;
    } else {
      const search = item.vaultSearchText.toLowerCase();
      item.filteredVaults = this.vaults.filter((v) => v.name.toLowerCase().includes(search));
    }
  }

  openTemplateDropdown(item: any) {
    item.showTemplateDropdown = !item.showTemplateDropdown;
    if (item.showTemplateDropdown) {
      item.templateSearchText = '';
      // Get all selected template ids except for this row
      const selectedTemplateIds = this.getTableDataSource()
        .filter((row) => row !== item && row.template)
        .map((row) => row.template.id);

      // First filter by vault_form_id if available
      let availableTemplates = this.templates;
      if (item.vaultUserForm?.vault_form_id) {
        availableTemplates = this.templates.filter((template) => template.vault_form_id === item.vaultUserForm.vault_form_id);
      }

      // Filter out already-selected templates
      item.filteredTemplates = availableTemplates.filter((t) => !selectedTemplateIds.includes(t.id));
    }
  }

  onTemplateSelect(item: any, template: any) {
    item.template = template;
    item.showTemplateDropdown = false;
    // Set vault from template
    if (template.vaultid && template.vaultname) {
      item.vault = { id: template.vaultid, name: template.vaultname };
      if (item.searchControl) {
        item.searchControl.setValue(item.vault, { emitEvent: false });
      }
      // Mark that this is the pre-selected vault (not manually changed)
      item.vaultManuallyChanged = false;
    }
    // Trigger change detection to update save button state
    this.cd.detectChanges();
  }

  // Click outside to close all vault dropdowns
  handleDocumentClick = (event: MouseEvent) => {
    // Vault dropdowns
    const vaultDropdowns = document.querySelectorAll('.vault-dropdown-list');
    let clickedInsideVault = false;
    vaultDropdowns.forEach((dropdown) => {
      if (dropdown.contains(event.target as Node)) {
        clickedInsideVault = true;
      }
    });
    const vaultTriggers = document.querySelectorAll('.selected-vault');
    vaultTriggers.forEach((trigger) => {
      if (trigger.contains(event.target as Node)) {
        clickedInsideVault = true;
      }
    });

    // Template dropdowns
    const templateDropdowns = document.querySelectorAll('.template-dropdown-list');
    let clickedInsideTemplate = false;
    templateDropdowns.forEach((dropdown) => {
      if (dropdown.contains(event.target as Node)) {
        clickedInsideTemplate = true;
      }
    });
    const templateTriggers = document.querySelectorAll('.selected-template');
    templateTriggers.forEach((trigger) => {
      if (trigger.contains(event.target as Node)) {
        clickedInsideTemplate = true;
      }
    });

    if (!clickedInsideVault) {
      this.getTableDataSource().forEach((row) => (row.showVaultDropdown = false));
    }
    if (!clickedInsideTemplate) {
      this.getTableDataSource().forEach((row) => (row.showTemplateDropdown = false));
    }
    if (!clickedInsideVault || !clickedInsideTemplate) {
      this.cd.detectChanges();
    }
  };

  filterTemplates(item: any) {
    // Get all selected template ids except for this row
    const selectedTemplateIds = this.getTableDataSource()
      .filter((row) => row !== item && row.template)
      .map((row) => row.template.id);

    // First filter by vault_form_id if available
    let availableTemplates = this.templates;
    if (item.vaultUserForm?.vault_form_id) {
      availableTemplates = this.templates.filter((template) => template.vault_form_id === item.vaultUserForm.vault_form_id);
    }

    if (!item.templateSearchText) {
      item.filteredTemplates = availableTemplates.filter((t) => !selectedTemplateIds.includes(t.id));
    } else {
      const search = item.templateSearchText.toLowerCase();
      item.filteredTemplates = availableTemplates.filter((t) => !selectedTemplateIds.includes(t.id) && t.type.toLowerCase().includes(search));
    }
  }

  ngOnDestroy(): void {
    document.removeEventListener('click', this.handleDocumentClick, true);
    this.subscription?.unsubscribe();
    if (this.widgetInstance) {
      this.widgetInstance.unmount();
    }
    // const widget = this.widgetInstances[this.dialogId];
    // if (widget) {
    //   widget.unmount();
    //   delete this.widgetInstances[this.dialogId];
    // }
    // if (this.mxConnectInstance) {
    //   const connectIframe = document.querySelector(`iframe[title="Connect"][id="widget-${this.dialogId}"]`);
    //   if (connectIframe) {
    //     connectIframe.remove();
    //   }
    //   this.mxConnectInstance = null;
    // }
  }
}
